
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadtrips/[id]",
      function () {
        return require("private-next-pages/roadtrips/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadtrips/[id]"])
      });
    }
  